import axios from 'axios';
import { Helpers } from '../helpers/Helpers';
import { AddCompanyAddressRequest } from '../models/request/companyAddress/AddCompanyAddressRequest';

export class CompanyAddressService {
    static async addCompanyAddress(inputObj: AddCompanyAddressRequest) {
        try {
            const formData = this.getFormData(inputObj);

            console.log('SERVICE CALL - AddCompanyAddress', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/CompanyAddress/AddCompanyAddress', formData);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getCompanyAddressByCountryIdAndPostalCode(_countryId: string | undefined, _postalCode: string | undefined) {
        try {
            var inputObj = {
                countryId: _countryId,
                postalCode: _postalCode
            }

            console.log('SERVICE CALL - GetCompanyAddressByCountryIdAndPostalCode', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/CompanyAddress/GetCompanyAddressByCountryIdAndPostalCode', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static getFormData(obj: any = {}, formData = new FormData(), key = '') {
        if (!([Array, File, Object].includes(obj.constructor))) {
            return formData;
        }

        // Handle File recursive
        if (obj instanceof File) {
            formData.append(key, obj);
            return formData;
        }

        for (const prop in obj) {
            // Validate value type
            if (obj[prop] && !([String, Number, Boolean, Array, Object, File].includes(obj[prop].constructor))) {
                continue;
            }

            // Set deep index of prop
            const deepKey = key ? key + `.${prop}` : prop;

            // Handle array
            if (Array.isArray(obj[prop])) {
                obj[prop].forEach((item: any, index: any) => {
                    this.getFormData(item, formData, `${deepKey}[${index}]`);
                })
                continue;
            }

            (typeof obj[prop] === 'object' && obj[prop] && obj[prop].constructor === Object)
                ? this.getFormData(obj[prop], formData, deepKey) // Handle object
                : formData.append(deepKey, [undefined, null].includes(obj[prop]) ? '' : obj[prop]) // Handle string, number, boolean
        }

        return formData;
    }
}